// Import: Middleware Action & Custom Types
import { CLEAN_MAKE_PREPAID, CLEAN_MAKE_PREPAID_ERROR } from '_models/redux/types';

// Action function
export const cleanMakePrepaid = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_MAKE_PREPAID,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_MAKE_PREPAID_ERROR,
      payload: undefined,
    });
  }
};
